(() => {
  if (!location.pathname.startsWith('/collections/')) return;
  if (window.__fauceteraFilterDiagnosticsInstalled) return;
  window.__fauceteraFilterDiagnosticsInstalled = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const input = args[0];
    const init = args[1];
    const requestUrl = typeof input === 'string' ? input : input?.url;
    const absoluteUrl = new URL(requestUrl, location.href);
    const isFacetRequest = absoluteUrl.pathname.startsWith('/collections/') && (absoluteUrl.searchParams.has('section_id') || absoluteUrl.searchParams.has('sections') || absoluteUrl.searchParams.has('filter.v.availability') || [...absoluteUrl.searchParams.keys()].some((key) => key.startsWith('filter.')));

    if (!isFacetRequest) {
      return originalFetch(...args);
    }

    const startedAt = performance.now();
    console.groupCollapsed('[Faucetera diagnostics] collection fetch');
    console.log('request', {
      url: absoluteUrl.href,
      hostname: absoluteUrl.hostname,
      pathname: absoluteUrl.pathname,
      method: init?.method || (typeof input !== 'string' ? input?.method : undefined) || 'GET',
      sectionId: absoluteUrl.searchParams.get('section_id'),
      sections: absoluteUrl.searchParams.getAll('sections'),
      filters: Object.fromEntries([...absoluteUrl.searchParams.entries()].filter(([key]) => key.startsWith('filter.'))),
      currentPage: location.href
    });

    try {
      const response = await originalFetch(...args);
      const clone = response.clone();
      const contentType = clone.headers.get('content-type') || '';
      let bodyText = '';

      try {
        bodyText = await clone.text();
      } catch (error) {
        bodyText = '';
      }

      const normalized = bodyText.toLowerCase();
      const hasZeroProducts = normalized.includes('0 products') || normalized.includes('no products match those filters');

      console.log('response', {
        status: response.status,
        ok: response.ok,
        redirected: response.redirected,
        finalUrl: response.url,
        contentType,
        durationMs: Math.round(performance.now() - startedAt),
        hasZeroProducts,
        responseBytes: bodyText.length
      });
      console.groupEnd();
      return response;
    } catch (error) {
      console.error('fetch error', error);
      console.groupEnd();
      throw error;
    }
  };
})();